export default "__VITE_ASSET__CXUvCeMr__"